<template>
    <div v-if="unitCate === 'C'">
        <CheckClaimIDAndBD
            v-model:id="no"
            v-model:bd="birthday"
            v-model:verify-code="verifyCode"
            @postApi="postApi"
        />
    </div>
    <div v-else>
        <CheckPdfIDAndBD
            v-model:id="no"
            v-model:bd="birthday"
            v-model:verify-code="verifyCode"
            @postApi="postApi"
        />
    </div>
    <div class="mt-4 flex flex-col md:flex-row">
        <div class="mt-4">
            誠摯邀請您下載【
            <a
                class="link link-primary"
                href="https://www.fubon.com/life/edmprod/app-promotion/index.html"
            >富邦人壽APP</a>
            】隨時線上查詢您的保單內容，升級交易會員還能隨時線上申辦保單服務，加入幸福more參與健康活動累積健康換好禮。即日起至115/12/31，只要下載並完成首次登入，就有機會抽中 iPhone 17
            Pro、AirPods Pro 3、千元mo幣等好禮。
        </div>
        <div class="flex items-center justify-center">
            <img
                :src="'./app-promotion.png'"
                alt=""
                class="max-w-[8rem] max-h-[8rem]"
            >
        </div>
    </div>
    <Loading :isLoading="isLoading" />
</template>

<script>
import { reactive, toRefs, inject, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import CheckPdfIDAndBD from '@/components/template/CheckPdfIDAndBD.vue';
import CheckClaimIDAndBD from '@/components/template/CheckClaimIDAndBD.vue';
import { getCate, postLoginNotify } from '@/apis/mNotifyPromo';

export default {
    components: {
        CheckPdfIDAndBD,
        CheckClaimIDAndBD,
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const route = useRoute();
        const unitCate = ref('');
        // const router = useRouter();
        const users = reactive({
            no: '',
            noErrorMsg: '',
            birthday: '',
            source: 'MNP',
            key: route?.query?.key,
            isLoading: false,
            verifyCode: '',
        });

        const postApi = async (canPost) => {
            if (canPost) {
                users.isLoading = true;
                console.log('submit unitCate:' + unitCate.value);
                if (await login()) {
                    const path = process.env.VUE_APP_API_PATH;
                    const baseUrl = `${window.location.origin}${path}`;
                    window.location.href = `${baseUrl}/api/external/smsNotify/pdf?key=${users.key}`;
                    users.isLoading = false;
                } else {
                    users.isLoading = false;
                }
            }
        };

        const openPopup = (err) => {
            const errorMessage = err.data?.errorMessage;
            const errorUpLimit = err.data?.errorUpLimit;
            const redirectUrl = err.data?.url;

            store.dispatch('mNotify/clearMember');
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '系統提示',
                    content: errorMessage || '系統忙碌中，請稍後再試',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                },
                on: {
                    confirm() {
                        if (errorUpLimit) {
                            window.location.href = redirectUrl;
                        } else {
                            $vfm.hide('DialogBase');
                        }
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                },
            });
        };
        (() => {
            store.dispatch('permissions/clearAll');
        })();

        const login = () => {
            const data = {
                id: users.no,
                birthday: users.birthday.split('/').join('').replace(/^0+/, ''),
                source: users.source,
                key: users.key,
                unitCate: unitCate.value,
                verifyCode: users.verifyCode,
            };
            return postLoginNotify(data).then(res => {
                store.dispatch('mNotify/setMember', res.data);
                return true;
            }).catch(err => {
                openPopup(err);
            });
        };

        const getUnitCate = async () => {
            users.isLoading = true;
            // claim or pay
            return await getCate(users.key).then(res => {
                unitCate.value = res.data.cate;
                console.log('unitCate.value:' + unitCate.value);
                users.isLoading = false;
            });
        };

        getUnitCate();

        return {
            ...toRefs(users),
            postApi,
            getUnitCate,
            unitCate,
        };
    },
};
</script>
